document.addEventListener('DOMContentLoaded', () => {
  const frontPageScrollerElem = document.querySelector('.mod-scroller');

  if (frontPageScrollerElem) {
    const scrollingSectionElement = document.querySelector('.intro-module__text');

    // eslint-disable-next-line
    const fullpageAnim = new fullpage('#fullpage', {
      licenseKey: 'K6P3H-D9O98-370K9-GWJSJ-YMRCO',
      normalScrollElements: '.intro-module__text, .sc-splash-screen',
      fixedElements: '.menu',
      scrollingSpeed: 500,
      css3: true,
      easing: 'easeInOutCubic',
      touchSensitivity: 15,
      onLeave: (origin, destination, direction) => {
        const section1 = origin.item.classList.contains('mod-scroller__section1');
        const section2 = destination.item.classList.contains('mod-scroller__section2');
        const section3 = origin.item.classList.contains('mod-scroller__section3');

        if (section1 && section2) {
          scrollingSectionElement.scrollTop = 2;
        }
        if (section3 && section2) {
          scrollingSectionElement.scrollTop = scrollingSectionElement.scrollHeight - scrollingSectionElement.clientHeight - 10;
        }

        // If not on first section then stop autoplay because of dissappearing text on iOS (performance issues also)
        if (destination.index === 0) {
          if (landingSlider) {
            landingSlider.autoplay.start();
          }
        } else {
          // eslint-disable-next-line
          if (landingSlider) {
            landingSlider.autoplay.stop();
          }
        }
      },
    });

    scrollingSectionElement.addEventListener('scroll', (event) => {
      if (Math.floor(scrollingSectionElement.scrollTop) + 2 + scrollingSectionElement.clientHeight > scrollingSectionElement.scrollHeight) {
        // eslint-disable-next-line
        fullpage_api.moveTo(3);
      }
      if (scrollingSectionElement.scrollTop === 0) {
        // eslint-disable-next-line
        fullpage_api.moveTo(1);
      }
    });
  }
});
